import { render } from "./Strategy.vue?vue&type=template&id=6c034093&scoped=true"
import script from "./Strategy.vue?vue&type=script&lang=js"
export * from "./Strategy.vue?vue&type=script&lang=js"

import "./Strategy.vue?vue&type=style&index=0&id=6c034093&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Administrateur\\Documents\\davca-cm\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c034093"]])

export default __exports__